import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 12px;

  ${breakpoints.up('tablet')} {
    max-width: 960px;
    margin: 0 auto;
  }
`

export const Body = styled.div`
  h1 {
    ${({ theme }) => theme.textStyles.titleH1};
    text-align: center;
  }

  h2 {
    ${({ theme }) => theme.textStyles.titleH2};
    margin: 20px 0 10px;
  }

  h3 {
    ${({ theme }) => theme.textStyles.titleH3};
    margin: 15px 0 10px;
  }

  p {
    ${({ theme }) => theme.textStyles.body};
    margin: 10px 0;
  }

  ul {
    ${({ theme }) => theme.textStyles.body};
    padding-left: 15px;
    margin: 10px 0;
    list-style-type: disc;
  }

  ol {
    ${({ theme }) => theme.textStyles.body};
    padding-left: 15px;
    margin: 10px 0;
    list-style-type: decimal;
  }

  li {
    margin-bottom: 5px;
  }

  a {
    ${({ theme }) => theme.textStyles.textBold};
    text-decoration: underline;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.pureBlack};

    &:hover {
      opacity: 0.8;
    }
  }

  strong {
    ${({ theme }) => theme.textStyles.textBold};
  }

  em {
    font-style: italic;
  }

  small {
    ${({ theme }) => theme.textStyles.tiny};
  }
`
